import * as React from 'react';
import { useState, useEffect } from 'react';
import { useListFilterContext } from 'react-admin';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/**
 * A FilterLiveSearch replacement that only triggers the filter
 * when the input value has at least `minLength` characters (or is empty/cleared).
 */
const MinLengthFilterLiveSearch = ({
    source = 'q',
    variant = 'outlined',
    minLength = 3,
    label = 'ra.action.search',
    placeholder,
}: {
    source?: string;
    variant?: 'outlined' | 'filled' | 'standard';
    minLength?: number;
    label?: string;
    placeholder?: string;
}) => {
    const { filterValues, setFilters } = useListFilterContext();
    const [value, setValue] = useState(filterValues[source] || '');
    const currentFilterValue = filterValues[source];

    // Sync local state when filter is cleared externally
    useEffect(() => {
        if (!currentFilterValue && value) {
            setValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentFilterValue]);

    // Debounce the filter application
    useEffect(() => {
        const timer = setTimeout(() => {
            if (value.length === 0) {
                const { [source]: _, ...rest } = filterValues;
                setFilters(rest, undefined, false);
            } else if (value.length >= minLength) {
                setFilters(
                    { ...filterValues, [source]: value },
                    undefined,
                    false
                );
            }
        }, 500);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const helperText =
        value.length > 0 && value.length < minLength
            ? `Syötä vähintään ${minLength} merkkiä`
            : ' ';

    return (
        <TextField
            value={value}
            onChange={e => setValue(e.target.value)}
            variant={variant}
            size="small"
            fullWidth
            placeholder={placeholder}
            helperText={helperText}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <SearchIcon color="disabled" />
                    </InputAdornment>
                ),
            }}
            sx={{ mb: 1 }}
        />
    );
};

export default MinLengthFilterLiveSearch;
